import { i18next } from '@yola/ws-sdk';

const getSearchTip = (locale) =>
  locale !== 'en' ? i18next.t('Use English keywords to get better results') : '';

export default getSearchTip;
